export default function Alert({children, className}){
    return (
        <div className={`p-6 bg-white border-2 border-black border-t-4 z-10 min-w-fit max-w-2xl normal-case ${className}`}>
            {children}
        </div>
    )
}